import styled, { keyframes } from 'styled-components';

const slideDown = keyframes`
  from {
    transform: translateY(-100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

export const NotificationContainer = styled.div`
  position: fixed;
  top: 1rem;
  left: 50%;
  transform: translateX(-50%);
  width: 21.875rem;
  z-index: 999999999999999999999999999999999999999999999999999999 !important;
`;

export const ToastWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0.5rem;
  color: rgba(0, 0, 0, 1);
  background: ${props => props.background};
  border-radius: 1.2rem;
  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.15);
  transition: opacity ${props => props.fadeDuration}ms ease-in-out;
  opacity: ${props => props.isVisible ? 1 : 0};
  pointer-events: ${props => props.isVisible ? 'auto' : 'none'};
  animation: ${slideDown} ${props => props.fadeDuration}ms ease-out;
`;

export const IconWrapper = styled.div`
  background-color: ${props => {
    switch (props.type) {
      case 'success':
        return 'rgba(163, 214, 92, 1)';
      case 'warning':
        return '#FFD439';
      default:
        return 'rgba(252, 82, 117, 1)';
    }
  }};
 
  padding: 0.6rem;
  border-radius: 0.8rem;
  margin-right: 0.5rem;


  svg{
    transform: ${props => {
    switch (props.type) {
      case 'success':
        return 'translateY(3px) ';
      case 'warning':
        return 'translateY(3px)';
      default:
        return 'translateY(3px)';
    }
  }};
  }
`;

export const ContentWrapper = styled.div`
  flex: 1;
`;

export const MessageText = styled.span`
  font-size: 1rem;
  font-weight: 450;
`;

export const CancelIconWrapper = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  margin-left:0;
  
  &:hover {
    opacity: 0.8;
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;